import { render, staticRenderFns } from "./ProctorGenerate.vue?vue&type=template&id=4e75bfa9&scoped=true"
import script from "./ProctorGenerate.vue?vue&type=script&lang=js"
export * from "./ProctorGenerate.vue?vue&type=script&lang=js"
import style0 from "./ProctorGenerate.vue?vue&type=style&index=0&id=4e75bfa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e75bfa9",
  null
  
)

export default component.exports